module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921122651_T.1d90e9b2.jpg";